import * as React from 'react';
const SettingsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g
      stroke={props.color || '#FFFFFF8C'}
      strokeLinecap="round"
      strokeOpacity={0.55}
      strokeWidth={1.333}
      clipPath="url(#a)"
      opacity={0.7}
    >
      <path d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
      <path d="M12.713 3.287A6.667 6.667 0 1 0 14 8" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SettingsIcon;
